import { useMemory } from './useMemory';

export const useResourceSingle = () => {
  const {setMemoryValue} = useMemory();
  const app = document.getElementById('app-order-now');
  const appProjectType = app.getAttribute('data-project-type');
  const appProjectPath = app.getAttribute('data-project-path');
  const appProjectTabs = app.getAttribute('data-project-tabs');
  const appProjectEndpoint = app.getAttribute('data-project-endpoint');

  if (appProjectTabs && appProjectTabs.length) {
    setMemoryValue('appProjectTabs', appProjectTabs);
  }

  const filterProjectsTypes = (projectsTypes) => {
    return appProjectType
      ? projectsTypes.filter(projectsType => projectsType === appProjectType)
      : projectsTypes;
  };

  const filterProjectsDetails = (projectsDetails) => {
    return appProjectType
      ? {[appProjectType]: {
          ...projectsDetails[appProjectType],
          endpoint: appProjectEndpoint,
          linkPathParent: '',
          linkPath: `/${appProjectPath}`
        }}
      : projectsDetails;
  };

  return {
    filterProjectsTypes,
    filterProjectsDetails
  };
};
